export const SALES_SPECIALISTS = ["陳宇澤", "林沐晴", "王子睿", "李若彤", "張皓軒", "劉語芯"];
